import React from 'react';
import {
  TextField,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useField, useFormikContext } from 'formik';

const useStyles = makeStyles(() => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
  },
  chip: {
    margin: 2,
    height: 24,
  },
}));

const MultiSelectWrapper = ({
  name,
  options,
  ...otherProps
}) => {
  const classes = useStyles();
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  // Parse the comma-separated string back to an array for display
  const selectedValues = field.value
    ? field.value.split(',').map(v => v.trim()).filter(Boolean)
    : [];

  const handleChange = (evt) => {
    const { value } = evt.target;
    // value is already an array because of SelectProps.multiple
    // Join as comma-separated string for Formik
    setFieldValue(name, value.join(','));
  };

  const configSelect = {
    ...field,
    ...otherProps,
    select: true,
    variant: 'outlined',
    fullWidth: true,
    value: selectedValues, // Must pass array for MUI multi-select
    onChange: handleChange,
    SelectProps: {
      multiple: true,
      renderValue: (selected) => (
        <div className={classes.chips}>
          {selected.map((val) => (
            <Chip
              key={val}
              label={options[val] || val}
              className={classes.chip}
              size="small"
            />
          ))}
        </div>
      ),
    },
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    configSelect.helperText = meta.error;
  }

  return (
    <TextField {...configSelect}>
      {Object.keys(options).map((item, pos) => (
        <MenuItem key={pos} value={item}>
          <Checkbox
            checked={selectedValues.indexOf(item) > -1}
            color="primary"
            size="small"
          />
          <ListItemText primary={options[item]} />
        </MenuItem>
      ))}
    </TextField>
  );
};

export default MultiSelectWrapper;
